

















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import NavigationFooter from '@/components/NavigationFooter.vue'
import TrackingMixin from '@/mixins/TrackingMixin.vue'
import { mapGetters, mapActions } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { isProperName, deepClone } from '@/utils'
import salutations from '@/store/data/salutations'
import IDefaultQuasarComponentItem from '@/store/interface/IDefaultQuasarComponentItem'
import { ICustomer } from '@/store/interface/ICustomer'
import englishCountries from '@/store/data/countries/englishCountries'
import CustomerService from '@/services/CustomerService'

/**
 * PassengerData Page
 *
 * On this page we gather necessary information regarding the customer that
 * want's to get his compensation back. After submitting a page it sends this
 * data to the backend
 */
@Component({
	name: 'PassengerDataPage',
	components: {
		PageHeader,
		NavigationFooter
	},
	mixins: [TrackingMixin],
	computed: {
		...mapGetters({
			customerData: 'customerData/getCustomerData',
			refundId: 'refundData/getRefundId'
		})
	},
	methods: {
		...mapActions({
			setCustomerData: 'customerData/setCustomerData'
		})
	},
	validations: {
		passengerData: {
			salutation: { required },
			firstName: { required, isProperName },
			lastName: { required, isProperName },
			email: { required, email },
			phone: { minLength: minLength(7) },
			address: {
				street: { required },
				postalCode: { required, minLength: minLength(2) },
				city: { required, isProperName },
				country: { required }
			}
		}
	}
})
export default class PassengerDataPage extends Vue {
	private customerData!: ICustomer
	private refundId!: string
	private setCustomerData!: Function
	private isPageValid: boolean = false
	private lang: string = ''
	private salutationsList: IDefaultQuasarComponentItem[] = salutations
	private passengerData: ICustomer = { ...this.customerData }
	private countryOptions: IDefaultQuasarComponentItem[] = englishCountries
	private filteredCountries: IDefaultQuasarComponentItem[] = [ ...this.countryOptions ]

	beforeMount () {
		const locale: string = this.$i18n.locale
		const lang: string = locale && locale.length === 5 ? locale.substring(0, 2) : 'en'

		this.lang = lang

		this.passengerData = deepClone<ICustomer>(this.customerData)

		/**
		 *  A workaround to prefill salutation sent from EmberCC, (which is always
		 * either `Mr` or `Ms`). As we have different values of titles depending on
		 * language, we need to explicity setup the value in proper language, so
		 * that the prefill will work. Otherwise, we won't have salutation prefill,
		 * because, the values like `Herr` on german domain will not be matched
		 * with `Mr`. It will work only for english titles.
		 */
		if (this.passengerData.salutation === 'Mr') {
			this.passengerData.salutation = `${this.$t('passengers.gender.male')}`
		} else if (this.passengerData.salutation === 'Ms') {
			this.passengerData.salutation = `${this.$t('passengers.gender.female')}`
		}

		// Fetch country list
		CustomerService.fetchCountries(lang)
			.then((response: any) => {
				this.countryOptions = response.data
			})
			.catch((e: Error) => {
				console.error('Error occured while trying to fetch country list: ', e)
			})
	}

	mounted () {
		this.isPageValid = !this.$v.$invalid

		if (this.refundId === '') {
			this.$router.push('step0')
		}
	}

	private onInput (): void {
		this.isPageValid = !this.$v.$invalid
	}

	private get translatedSalutations (): IDefaultQuasarComponentItem[] {
		const salutations = this.salutationsList.map((el: IDefaultQuasarComponentItem) => {
			if (el.label.indexOf('.') !== -1) {
				el.label = `${this.$t(el.label)}`
				el.value = `${this.$t(el.value)}`
			}
			return el
		})

		return salutations
	}

	private onPageSubmit (): void {
		const payload = {
			refundId: this.refundId,
			customerData: this.passengerData
		}

		this.setCustomerData(payload)
			.then((data: any) => {
				// Additional subscription for mailchimp
				if (this.passengerData.consentToStoreData) {
					CustomerService.subscribeNewsLetter(this.refundId, this.lang)
				}
				// route to the next page
				this.$router.push('step7')
			})
			.catch((e: Error) => console.error(e))
	}

	private onCountryFilter (query: string, update: Function): void {
		const val: string = query.toLowerCase()

		this.filteredCountries = this.countryOptions.filter((el: IDefaultQuasarComponentItem) => {
			const label: string = el.label.toLowerCase()
			if (label.indexOf(val) > -1) {
				return el
			}
		})

		// update is the callback function of QSelect, that updates the dropdown
		update()
	}
}
